"use client";

import { DamacAPI } from "@utils/damac/api";
import { DEFAULT_CURRENCY, DEFAULT_MEASUREMENT } from "@utils/default";
import { getCookie } from "cookies-next";
import { useSession } from "next-auth/react";
import { FC, ReactNode, createContext, useEffect, useState } from "react";

interface Props {
  children: ReactNode;
}
interface ShortlistContextProps {
  units: any[];
}
export const ShortlistContext = createContext<ShortlistContextProps>({
  units: [],
});

const ShortlistContextProvider: FC<Props> = ({ children }) => {
  const [units, setUnits] = useState<any>([]);
  const { data: session } = useSession();

  useEffect(() => {
    const fetchShortlist = async () => {
      const config = {
        currency: getCookie("currency") || DEFAULT_CURRENCY,
        measurement: getCookie("measurement") || DEFAULT_MEASUREMENT,
      };
      const api = new DamacAPI(config);
      let shortlist;
      if (session?.user) {
        shortlist = await api.shortlist(session.user.id);
      } else {
        const favorites = getCookie("favorites");
        const productIds = favorites ? favorites.split(" ") : [];
        shortlist = await api.shortlist(undefined, productIds);
      }
      setUnits(shortlist?.units || []);
    };
    fetchShortlist();
  }, [session]);

  return <ShortlistContext.Provider value={{ units }}>{children}</ShortlistContext.Provider>;
};
export default ShortlistContextProvider;
